import { Link, useNavigate, useLocation } from "react-router-dom";
import TopMenu from "./TopMenu";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleRegistrationClick = () => {
    // If we're already on the registration page, just scroll to the section
    if (location.pathname === "/registration") {
      const element = document.getElementById("payment-selection");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } else {
      // Navigate to registration page with hash
      navigate("/registration/#payment-selection");
    }
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg header-transparent bg-transparent disable-fixed">
        <div className="container-fluid">
          {/* Logo Section - Left for English, Right for Arabic */}
          <div className="col-12 col-md-auto col-lg-3 d-flex justify-content-start">
            <Link className="navbar-brand" to="/">
              <img
                src="/images/logos/apcg-ubt-white-logo.png"
                alt=""
                className="default-logo"
                style={{ maxHeight: "70px" }}
              />
              <img
                src="/images/apcg-logo-2.png"
                alt=""
                className="mobile-logo"
                style={{ maxHeight: "60px" }}
              />
              <img
                src="/images/ubt-logo-mobile.png"
                alt=""
                className="mobile-logo"
                style={{ maxHeight: "60px" }}
              />
            </Link>
          </div>
          
          {/* Navigation Menu - Center */}
          <TopMenu />
          
          {/* Language Selector and Buttons - Right for English, Left for Arabic */}
          <div className="col-auto d-flex align-items-center language-nav-container">
            <LanguageSelector />
            <div className="header-icon d-flex gap-2">
              {/* Submit Paper button temporarily hidden */}
             <a
                href="https://www.openconf.org/apcg2026_saudiarabia/openconf.php"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-small text-transform-none btn-gradient-apcg border-1 left-icon btn-rounded fw-500"
                style={{ fontSize: "14px", padding: "10px 16px" }}
              >
              
                <span className="d-lg-none">{t("navigation.submitPaper")}</span>
                <span className="d-none d-lg-inline">{t("navigation.submitPaper")}</span>
              </a> 
              <button
                onClick={handleRegistrationClick}
                className="btn btn-small text-transform-none btn-gradient-apcg border-1 left-icon btn-rounded fw-500"
                style={{ fontSize: "14px", padding: "10px 16px" }}
              >
                <i className="feather icon-feather-mail d-none d-lg-inline-block" style={{ fontSize: "16px" }} />
                <span className="d-lg-none">{t("navigation.registration")}</span>
                <span className="d-none d-lg-inline">{t("navigation.registration")}</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
